import React from 'react';
import { Col, Row } from 'antd';

import { InputStyled, FormItemStyled } from './RewardForm.style';

interface Props {
  validateRequired: (value: string) => string | undefined;
}

export const PhysicalRewardForm: React.FunctionComponent<Props> = ({ validateRequired }) => {
  const validatePhoneNumber = (value: string): string | undefined => {
    const phoneNumberRegex = /^[\d\s.\-+]+$/u;
    return phoneNumberRegex.test(value)
      ? undefined
      : 'numéro de téléphone invalide';
  };

  return (
    <>
      <FormItemStyled
        name="firstName"
        label="Prénom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="firstName" placeholder="Martin" />
      </FormItemStyled>
      <FormItemStyled
        name="lastName"
        label="Nom"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="lastName" placeholder="Dupont" />
      </FormItemStyled>
      <FormItemStyled
        name="phone"
        label="Téléphone"
        required
        validate={(value) => validateRequired(value) ?? validatePhoneNumber(value)}
        labelCol={{ span: 24 }}
        tooltip="Votre numéro est obligatoire pour le suivi de votre livraison"
      >
        <InputStyled name="phone" placeholder="+33 06 45 45 45 45" />
      </FormItemStyled>
      <FormItemStyled
        name="address"
        label="Adresse"
        required
        validate={validateRequired}
        labelCol={{ span: 24 }}
      >
        <InputStyled name="address" placeholder="8 rue Jules Ferry" />
      </FormItemStyled>
      <FormItemStyled
        name="additionalAddress"
        label="Complément d'adresse"
        labelCol={{ span: 24 }}
      >
        <InputStyled name="additionalAddress" placeholder="3ème étage, porte B" />
      </FormItemStyled>
      <Row>
        <Col span={8}>
          <FormItemStyled
            name="zipCode"
            label="Code postal"
            required
            validate={validateRequired}
            labelCol={{ span: 24 }}
          >
            <InputStyled name="zipCode" placeholder="75001" />
          </FormItemStyled>
        </Col>
        <Col span={15} offset={1}>
          <FormItemStyled
            name="city"
            label="Ville"
            required
            validate={validateRequired}
            labelCol={{ span: 24 }}
          >
            <InputStyled name="city" placeholder="Paris" />
          </FormItemStyled>
        </Col>
      </Row>
    </>
  );
};
